<template>
  <b-card class="login-card">
    <section>
      <header class="text-align-center">
        <img class="brand" src="@/assets/logo.png" />
      </header>
      <div class="body">
        <h2>Welcome.</h2>
        <p class="text-muted auth-message">Please login to your account</p>
        <form class="no-margin" @submit.prevent="processLogin">
          <fieldset>
            <div class="form-group">
              <div class="input-group input-group-md">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-user"></i></span>
                </div>
                <input name="email" type="email" class="form-control input-lg" v-model.trim.lazy="email" v-validate="'required|email'" :class="{'is-invalid': errors.has('email') }" placeholder="Email">
              </div>
              <b-form-text class="is-invalid help" v-show="errors.has('email')">
                {{ errors.first('email') }}
              </b-form-text>
            </div>

            <div class="form-group">
              <div class="input-group input-group-md">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fa fa-lock"></i></span>
                </div>
                <input name="password" :type="passwordInputType" class="form-control input-lg" v-model.trim="password" v-validate="'required'" :class="{'is-invalid': errors.has('password') }" placeholder="Password">
                <div class="input-group-append">
                  <span class="input-group-text"
                    @mousedown="showPassword"
                    @touchstart="showPassword"
                    @mouseleave="hidePassword"
                    @mouseup="hidePassword"
                    @touchend="hidePassword"
                    @touchcancel="hidePassword"
                  ><i class="far" :class="viewPasswordIcon"></i></span>
                </div>
              </div>
              <b-form-text class="is-invalid help" v-show="errors.has('password')" v-html="errors.first('password')">
              </b-form-text>
            </div>
          </fieldset>
          <div class="form-actions">
            <button type="submit" class="btn btn-success btn-lg btn-block">
              <span class="" v-if="loading">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
              <small> Sign In</small>
            </button>
            <!-- <div class="forgot">
              No account? <router-link :to="{name: 'Register'}">Register</router-link>
              <br/>
              <router-link :to="{name: 'Register'}" class="forgot">Forgot Password?</router-link>
            </div> -->
          </div>
        </form>
      </div>
    </section>
  </b-card>
</template>

<script>
import { LOGIN_MUTATION } from '@/constants/graphql'
import { saveSession, isLoggedIn } from '@/lib/auth'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      showPasswordInterval: false,
      passwordInputType: 'password',
      loading: false,
      returnUrl: this.$route.query.redirect || '/dashboard'
    }
  },
  computed: {
    viewPasswordIcon () {
      return (this.passwordInputType === 'password') ? 'fa-eye-slash' : 'fa-eye'
    }
  },
  methods: {
    showPassword () {
      if (!this.showPasswordInterval) {
        this.showPasswordInterval = setInterval(() => {
          this.passwordInputType = 'text'
        }, 30)
      }
    },
    hidePassword () {
      clearInterval(this.showPasswordInterval)
      this.showPasswordInterval = false
      this.passwordInputType = 'password'
    },
    processLogin () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true

          const formData = {
            email: this.email,
            password: this.password
          }

          this.$apollo.mutate({
            mutation: LOGIN_MUTATION,
            variables: formData
          }).then((result) => {
            saveSession(result.data.login)
            this.loading = false
            this.$swal.fire({ icon: 'success', title: 'Success! Logged In' })
            this.$router.push(this.returnUrl)
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }
  },
  beforeCreate () {
    if (isLoggedIn()) {
      this.$router.push({ 'name': 'Dashboard' })
    }
    document.body.classList.add('photo-bg')
  }
}
</script>

<style>
</style>
